


import {
  MagicCard,
  MagicContainer,
} from "../components/magicui/magic-card.tsx";
import axios from 'axios';
import IconFire from "../imgs/icons/fire.png";
import IconArrows from "../imgs/icons/arrows.svg";
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { cn } from "../lib/utils.tsx";
import { Navigation, Autoplay } from 'swiper/modules';
import IconGift from "./../imgs/icons/gift.svg";

function Tarifs(args) {

  const [Loading, setLoading] = useState(true)
  const [pricing, Setpricing] = useState([])
  const [Discount, setDiscount] = useState({})


  useEffect(() => {
    async function get_tarifs() {
      // Update the document title using the browser API
      //console.log(args)
      try {
        var auth_token = window.x_moon_token || localStorage.getItem('x_moon_token');

        const response = await axios.get(args.ApiUrl + "plans", { headers: { "Authorization": "Bearer " + auth_token } });

        localStorage.setItem('pricing', JSON.stringify(response.data?.plans));

        Setpricing(response.data?.plans);
        setDiscount({ discount: response.data?.discount, valid: response.data?.discount_valid });

        if (args.preSelect) {
          let url = new URL(window.location.href);
          url.searchParams.delete('select_plan');
          window.history.pushState({}, document.title, url.toString());

          for (var plan_index in response.data?.plans) {
            if (Number(args.preSelect) == response.data?.plans[plan_index].id) {
              args.onSelect(response.data?.plans[plan_index]);
            }
          }
        } else {

          setLoading(false);
        }

      } catch (error) {

        console.error('Ошибка при выполнении запроса:', error);
        if (localStorage.getItem("pricing")) {

          Setpricing(JSON.parse(localStorage.getItem("pricing")));
          setLoading(false);
        }
      }

    }
    get_tarifs();




    // setTimeout(()=>{setLoading(false)},1000)
  }, []);
  var autoplay = { delay: (args.isLk ? 5000 : 2500), disableOnInteraction: true }


  return (


    <div className="w-full h-full">

      {(Discount.discount != 0 && Discount.discount) &&
       <MagicCard
       borderWidth={3}
       className="flex w-full flex-col overflow-hidden bg-[radial-gradient(var(--mask-size)_circle_at_var(--mouse-x)_var(--mouse-y),#ffaa40_0,#9c40ff_50%,transparent_100%)] px-2 shadow-2xl"
     >
        <div className="px-4 flex gap-3 items-center shadow-md">
      <img src={IconGift} className="h-12" />
      <span className="text-xl text-gray-200 font-bold w-full">
        Для вас действует скидка {Discount.discount}% на все тарифы!
      </span>
      <span class="relative hidden sm:flex h-3 w-3 ">
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
        <span class="relative inline-flex rounded-full h-3 w-3 bg-indigo-500"></span>
      </span>
      </div>
    </MagicCard>
}

{
  !Loading &&
  <>
    <Swiper navigation={false} autoplay={autoplay} slidesPerView={'auto'} spaceBetween={30} modules={[Navigation, Autoplay]} className="sm:!hidden mt-4 sm:mt-8">
      {pricing.map((item) => (
        <SwiperSlide>
          <MagicCard
            borderWidth={3}
            className="flex w-full cursor-pointer flex-col items-center overflow-hidden bg-[radial-gradient(var(--mask-size)_circle_at_var(--mouse-x)_var(--mouse-y),#ffaa40_0,#9c40ff_50%,transparent_100%)] px-12 pt-10 shadow-2xl"
          >
            <div>
              <span className="whitespace-nowrap text-2xl sm:text-3xl font-black text-gray-200 flex items-center gap-2">{item.name}  {(item.isPromo == 1 || item.personal) && <img src={IconFire} className="h-6" />}</span>
              <span className="mt-3 text-lg text-gray-300 font-normal block">{item.desc}</span>
              <span className="mt-5 block text-3xl font-bold text-gray-200 ">{item.price} ₽</span>
              {!item.available &&

                <button
                  disabled
                  className="text-gray-900  hover:scale-105 duration-300 mt-5 block w-full rounded-md bg-gray-400 px-3.5 py-2.5 text-lg font-semibold text-gray-100 shadow-sm text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
                >
                  Недоступно
                </button>

              }
              {item.available &&
                <>
                  {(item.isPromo == 1 || item.personal) &&
                    <button
                      onClick={() => { args.onSelect(item); }}
                      className="shadow-lg shadow-indigo-500/50 hover:scale-105 duration-300 mt-5 block w-full rounded-md bg-gradient-to-r from-[#e90ffc] to-[#13cbe1] px-3.5 py-2.5 text-lg font-semibold text-gray-100 shadow-sm hover:bg-violet-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
                    >
                      {!args.isLk &&
                        <span>Подключить</span>
                      }

                      {(args.isLk) &&
                        <span>Выбрать</span>
                      }
                    </button>
                  }
                  {(!item.isPromo && !item.personal) &&
                    <button
                      onClick={() => { args.onSelect(item); }}
                      className="text-gray-900  hover:scale-105 duration-300 mt-5 block w-full rounded-md bg-gray-200 px-3.5 py-2.5 text-lg font-semibold text-gray-100 shadow-sm text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
                    >
                      {!args.isLk &&
                        <span>Подключить</span>
                      }
                      {args.isLk &&
                        <span>Выбрать</span>
                      }
                    </button>
                  }
                </>
              }
            </div>
            <div className="pointer-events-none absolute inset-0 h-full bg-[radial-gradient(circle_at_50%_120%,rgba(120,119,198,0.3),rgba(255,255,255,0))]" />
          </MagicCard>
        </SwiperSlide>
      ))}

    </Swiper>
    <div className="w-full flex justify-center mt-3 sm:!hidden">
      <img src={IconArrows} className="h-12" />
    </div>
  </>
}







{
  !Loading &&
  <>
    <MagicContainer
      className={
        "grid sm:grid-cols-2 grid-cols-1 mt-4 w-full flex-col gap-4 lg:flex-row pb-8"
      }
    >
      {pricing.map((item) => (
        <MagicCard
          borderWidth={3}
          className="hidden sm:flex w-full cursor-pointer flex-col items-center overflow-hidden bg-[radial-gradient(var(--mask-size)_circle_at_var(--mouse-x)_var(--mouse-y),#ffaa40_0,#9c40ff_50%,transparent_100%)] px-12 pt-10 shadow-2xl"
        >
          <div>
            <span className="whitespace-nowrap text-2xl sm:text-3xl font-black text-gray-200  flex items-center gap-2">{item.name} {(item.isPromo == 1 || item.personal) && <img src={IconFire} className="h-6" />}</span>
            <span className="mt-3 text-lg text-gray-300 font-normal block">{item.desc}</span>
            <span className="mt-5 block text-3xl font-bold text-gray-200">{item.price} ₽</span>

            {!item.available &&

              <button
                disabled
                className="text-gray-900  hover:scale-105 duration-300 mt-5 block w-full rounded-md bg-gray-400 px-3.5 py-2.5 text-lg font-semibold text-gray-100 shadow-sm text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
              >
                Недоступно
              </button>

            }
            {item.available &&
              <>
                {(item.isPromo == 1 || item.personal) &&
                  <button
                    onClick={() => { args.onSelect(item); }}
                    className="shadow-lg shadow-indigo-500/50 hover:scale-105 duration-300 mt-5 block w-full rounded-md bg-gradient-to-r from-[#e90ffc] to-[#13cbe1] px-3.5 py-2.5 text-lg font-semibold text-gray-100 shadow-sm hover:bg-violet-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
                  >
                    {!args.isLk &&
                      <span>Подключить</span>
                    }

                    {(args.isLk) &&
                      <span>Выбрать</span>
                    }
                  </button>
                }
                {(!item.isPromo && !item.personal) &&
                  <button
                    onClick={() => { args.onSelect(item); }}
                    className="text-gray-900  hover:scale-105 duration-300 mt-5 block w-full rounded-md bg-gray-200 px-3.5 py-2.5 text-lg font-semibold text-gray-100 shadow-sm text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
                  >
                    {!args.isLk &&
                      <span>Подключить</span>
                    }
                    {args.isLk &&
                      <span>Выбрать</span>
                    }
                  </button>
                }
              </>
            }

          </div>
          <div className="pointer-events-none absolute inset-0 h-full bg-[radial-gradient(circle_at_50%_120%,rgba(120,119,198,0.3),rgba(255,255,255,0))]" />
        </MagicCard>
      ))}
    </MagicContainer>
  </>
}

{
  Loading &&
  <>
    <MagicContainer
      className={
        "grid sm:grid-cols-2 grid-cols-1 mt-4 sm:mt-8 w-full flex-col gap-4 lg:flex-row pb-8"
      }
    >
      {[1, 2, 3, 4].map((item) => (
        <MagicCard
          borderWidth={3}
          className={cn(
            (item > 1 ? "hidden sm:flex" : "flex"),
            "w-full cursor-pointer flex-col items-center overflow-hidden bg-[radial-gradient(var(--mask-size)_circle_at_var(--mouse-x)_var(--mouse-y),#ffaa40_0,#9c40ff_50%,transparent_100%)] px-12 pt-10 shadow-2xl",

          )}

        >
          <div className="w-full">
            <span className="whitespace-nowrap text-3xl font-black text-gray-200"><div className="h-8 rounded-md bg-gray-700 w-[50%] mb-4 animate-pulse"></div></span>
            <span className="mt-3 text-lg text-gray-300 font-normal block flex flex-col"><div className="h-2.5 rounded-md bg-gray-700 w-[70%] mb-4 animate-pulse"></div><div className="h-2.5 rounded-md bg-gray-700 w-[90%] mb-4 animate-pulse"></div></span>
            <span className="mt-5 block text-3xl font-bold text-gray-200 flex items-center gap-2"><div className="h-8 rounded-md bg-gray-700 w-24 animate-pulse"></div></span>

            <div className="h-12 rounded-md bg-gray-700 w-full animate-pulse mt-5"></div>

          </div>
          <div className="pointer-events-none absolute inset-0 h-full bg-[radial-gradient(circle_at_50%_120%,rgba(120,119,198,0.3),rgba(255,255,255,0))]" />
        </MagicCard>
      ))}
    </MagicContainer>
  </>
}

    
    </div >

  );
}

export default Tarifs;

